import React, { FC } from "react";
import styled from "styled-components";

import useDoubleClick from "../../hooks/useDoubleClick/useDoubleClick";

import { stopEventPropagation } from "./helpers";

const DoubleTapStyled = styled.div`
  border-radius: 100%;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  width: 50%;
  z-index: 1;

  & + & {
    left: auto;
    right: 0;
    transform: translateX(50%);
  }

  /* stylelint-disable-next-line no-descending-specificity */

  &,
  &:focus {
    outline: none !important;
  }
`;

const DoubleTap = ({ onDoubleTap, onSingleTap }) => (
  <DoubleTapStyled
    onClick={useDoubleClick({
      doubleClickDelay: 400,
      onClick: onSingleTap,
      onDoubleClick: onDoubleTap
    })}
    onFocus={stopEventPropagation}
    onMouseMove={e => stopEventPropagation(e)}
    onMouseOut={stopEventPropagation}
    tabIndex={-1}
  />
);

interface Props {
  onSeekFor: (amount: number) => void;
  showActionIcon: (icon: string) => void;
  toggleControls: (showControls?: boolean) => void;
}

export const DoubleTaps: FC<Props> = ({
  onSeekFor,
  showActionIcon,
  toggleControls
}) => (
  <>
    <DoubleTap
      onDoubleTap={() => {
        onSeekFor(-10);
        showActionIcon("back");
        toggleControls(false);
      }}
      onSingleTap={toggleControls}
    />
    <DoubleTap
      onDoubleTap={() => {
        onSeekFor(10);
        showActionIcon("forward");
        toggleControls(false);
      }}
      onSingleTap={toggleControls}
    />
  </>
);
